var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tinymce-editor',{attrs:{"init":_vm.editorInit,"disabled":!_vm.enableEditor},model:{value:(_vm.editorValue),callback:function ($$v) {_vm.editorValue=$$v},expression:"editorValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }